export const formatDateTime = (time: string | number | Date) => {
  const localTime = new Date(time).toLocaleTimeString();
  const localDate = new Date(time).toLocaleDateString();
  return localDate + " " + localTime;
};
